module.exports = "/_next/static/images/ArtificialIntelligence@2x-432c073aae4d7b4f6c715bc26f609dc7.png";